import React, { useState, useMemo, useCallback, createRef } from "react";

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Button from "../../../shared/controls/button";
import { RequisitionDetailCenter, RequisitionDetailLeft } from "./style";
import { AG_GRID_LOCALE_ES } from "../../../shared/language";
import ReactTooltip from "react-tooltip";
import { calculateGrossWeightProducts, calculateNetWeightProducts, calculateVolumeProducts } from "../../../shared/utils";
import moment from 'moment';
import { cloneDeep } from "lodash";
import CopyIcon from "../../../shared/icons/copy-icon";

const getCellView = (key, params, props) => { 
  let view = null;

  switch(key) {
    case 'suffix':
      view = <RequisitionDetailLeft> 
        {`${params.data.suffix || ''}`}
        <CopyIcon className="copy-icon-style" fill={"#000000"} height="16px" width="16px" onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          
          navigator.clipboard.writeText(params.data.suffix); 
        }}/>
      </RequisitionDetailLeft>
      break;
    case 'requisition_code':
      view = <RequisitionDetailLeft> 
        {`${params.data.requisition_code || ''}`}
        <CopyIcon className="copy-icon-style" fill={"#000000"} height="16px" width="16px" onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          
          navigator.clipboard.writeText(params.data.requisition_code); 
        }}/>
      </RequisitionDetailLeft>
      break;
    case 'delivery_id':
      view = <RequisitionDetailLeft><img style={{height: 25, width: 25}} alt="" className="logo" src="/images/dots.png" /></RequisitionDetailLeft>
      break;
    case 'collection_date':
      view = <RequisitionDetailLeft>
        {
          params.value ? <div>{moment(params.value).format('DD/MM/YYYY')}</div> : <div>{'-'}</div>
        }
        {/* <img
          alt=""
          src="/images/edit.png"
          style={{ cursor: "pointer", marginLeft: 10, width: 21, height: 21 }}
          onClick={() => {
            props.handleChange({
              target: {
                name: "modify-appointment-loading",
                value: 'Funcion de cambiar fecha de recolección'
              }
            });
          }}
        /> */}
      </RequisitionDetailLeft>
      break;
    case 'delivery_date':
      view = <RequisitionDetailLeft>
        {
          params.value ? <div>{moment(params.value).format('DD/MM/YYYY')}</div> : <div>{'-'}</div>
        }
        {/* <img
          alt=""
          src="/images/edit.png"
          style={{ cursor: "pointer", marginLeft: 10, width: 21, height: 21 }}
          onClick={() => {
            props.handleChange({
              target: {
                name: "modify-appointment-loading",
                value: 'Funcion de cambiar fecha de envio'
              }
            });
          }}
        /> */}
      </RequisitionDetailLeft>
      break;
    case 'gross_weight_total':
    case 'net_weight_total':
      view = <RequisitionDetailLeft>{`${params.value} kg`}</RequisitionDetailLeft>
    break;
    case 'requisition_created':
      view = <RequisitionDetailLeft>{ params.value ? `${moment(params.value).format('DD/MM/YYYY')}`: '-'}</RequisitionDetailLeft>
    break;
    case 'cta':
      const isRow = params.node.data;
      if (!isRow) { view = <div></div>; break; }

      let order_status = props.orderDetail.order_statusid;

      if (order_status === 1) {
        view = <div style={{width: '100%', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <Button 
            text='Confirmar'
            type='primary small'
            onClick={() => {
              props.handleChange({
                target: {
                  name: "confirm_order",
                  value: props.orderDetail
                }
              });  
            }}
          />
        </div>
      } else if (order_status === 2) {
        view = <div style={{width: '100%', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <Button 
            text='Convertir en Embarque'
            type='primary small'
            onClick={() => {
              props.handleChange({
                target: {
                  name: "convert-to-trip",
                  value: props.orderDetail
                }
              });  
            }}
          />
        </div>
      }
      break;
    case 'qty':
      view = <div style={{display: 'flex', alignItems: 'center'}}>
        <div>{params.value}</div>

        {/* <img
          alt=""
          src="/images/edit.png"
          style={{ cursor: "pointer", marginLeft: 10, width: 21, height: 21 }}
          onClick={() => {
            props.handleChange({
              target: {
                name: "modify_product_data",
                value: params.data
              }
            });
          }}
        /> */}
        
      </div>;
      break;
    default:
      view = <div></div>;
  }

  return view
};

const filterRequisitionCreation = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    let dates = [];

    (cellValue || []).map( item => {
      try {
        let m = moment(item.created);
        m.set({hour:0,minute:0,second:0,millisecond:0});

        dates.push(m.unix());
      } catch(e) {
        console.log(`Error de convertir fecha ${e}`);
      }
    });

    let result = -1;

    dates.map(item => {
      if (`${filterLocalDateAtMidnight.getTime()}`.includes(`${item}`)) {
        result = 0;
        return;
      }

      if (moment(item).isBefore(moment(filterLocalDateAtMidnight.getTime()))) {
        result = -1;
        return;
      }

      if (moment(item).isAfter(moment(filterLocalDateAtMidnight.getTime()))) {
        result = 1;
        return;
      }
    });

    return result;
  }
};

const filterParams = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    const dateAsString = cellValue;
    if (dateAsString == null) return -1;
    const dateParts = dateAsString.split("/");
    const cellDate = new Date(
      Number(dateParts[2]),
      Number(dateParts[1]) - 1,
      Number(dateParts[0]),
    );

    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
      return 0;
    }

    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }

    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
    return 0;
  }
};

const filterParamsStatusListFormatter = params => {
  let r = params.value;
  let new_value = '';

  if (r === null) return '';

  if (Array.isArray(r)) {
    if (r.length > 0) {
      new_value = (typeof r[0] === "object") ? r[0].description : r;
    }
  } else {
    new_value = (typeof r === "object") ? r.description : r;
  }

  return new_value;
}

const filterLastUpdate = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    let date = null;

    try {
      let m = moment(cellValue.date || cellValue);
      m.set({hour:0,minute:0,second:0,millisecond:0});

      date = m.unix();
    } catch(e) {
      console.log(`Error de convertir fecha ${e}`);
    }

    if (date === null) {
      return -1;
    }

    if (`${filterLocalDateAtMidnight.getTime()}`.includes(`${date}`)) {
      return 0;
    }

    if (moment(date).isBefore(moment(filterLocalDateAtMidnight.getTime()))) {
      return -1;
    }

    if (moment(date).isAfter(moment(filterLocalDateAtMidnight.getTime()))) {
      return 1;
    }

    return 0;
  }
};

const filterParamsStatusList = {
  valueFormatter: filterParamsStatusListFormatter
}

const getCorrectName = (field, default_columns) => {
  let column = default_columns.filter( item => item.field === field);
  return (column && column.length > 0) ? column[0].headerName : null;
}

const getColumnsWithCustomCells = (columns, default_columns, props) => {

  columns.map( (item, index) => {

    let new_header_name = getCorrectName(item.field, default_columns);
    if (new_header_name !== null) {
      columns[index].headerName = new_header_name;
    }

    if (['collection_date', 'delivery_date', 'net_weight_total', 'gross_weight_total', 'delivery_id', 'requisition_created', 'requisition_code', 'suffix'].includes(item.field)) {
      columns[index].cellRenderer = params => {
        return getCellView(item.field, params, props)
      }
    }

    if ([].includes(item.field)) {
      columns[index].filterParams = filterParamsStatusList;
      columns[index].filter = "agSetColumnFilter";
      columns[index].valueFormatter = filterParamsStatusListFormatter;
    }

    if (['last_update', 'order_created'].includes(item.field)) {
      columns[index].filterParams = filterLastUpdate;
      columns[index].filter = "agDateColumnFilter";
    }

    if (['requisition_created'].includes(item.field)) {
      columns[index].filterParams = filterRequisitionCreation;
      columns[index].filter = "agDateColumnFilter";
    }

  })

  return columns;
}

const applyNewColumns = (temp_colDefs, props) => {

  if (props.configuration['columns'] !== undefined && typeof props.configuration['columns'] === "object") {

    let temp_columns = props.configuration['columns'];

    if (temp_columns.length === temp_colDefs.length) {
      return getColumnsWithCustomCells(temp_columns, temp_colDefs, props);
    }

    try {

      let currentColumns = temp_colDefs.map( item => item.field);
      let currentColumnsSaved = props.configuration['columns'].map( item => item.field);
      let difference = currentColumns.filter(x => !currentColumnsSaved.includes(x));

      let newColumnsToAdd = [];

      temp_colDefs.map( (item, index) => {
        if (difference.includes(item.field)) {
          newColumnsToAdd.push({
            index,
            column: item
          })
        }
      });

      newColumnsToAdd.map( item => {
        temp_columns.splice(item.index, 0, item.column);
      });

      return getColumnsWithCustomCells(temp_columns, temp_colDefs, props);

    } catch (error) {
      console.error('Error setting columns definitions', error);

      return getColumnsWithCustomCells(temp_columns, temp_colDefs, props);
    }
  }
}

export const OrderDetailTableView = (props) => {

  const gridRef = createRef();
  const [rowData, setRowData] = useState(props.rowData);
  const [called, setCalled] = useState(false);

  let default_columns = [
    { headerName: '', field: 'requisition_id_checkbox', suppressMenu: true,  minWidth: 80, width: 80, sortable: true, cellRenderer: "agGroupCellRenderer",},
    { headerName: 'Pedido', field: 'requisition_code',  minWidth: 250, filter: 'agTextColumnFilter', suppressMenu: true, sortable: true,
      cellRenderer: params => {
        return getCellView('requisition_code', params, props)
      }
    },
    { headerName: 'Fecha de Creación del Pedido', field: 'requisition_created', minWidth: 250, filter: 'agDateColumnFilter', filterParams: filterRequisitionCreation, suppressMenu: true, sortable: true,
      cellRenderer: params => {
        return getCellView('requisition_created', params, props)
      }
    },
    { headerName: 'Entrega', field: 'suffix', suppressMenu: true, filter: 'agTextColumnFilter', minWidth: 200, sortable: true,
      cellRenderer: params => {
        return getCellView('suffix', params, props)
      }
    },
    { headerName: 'Fecha Deseada de Recolección', field: 'collection_date', minWidth: 310, filter: 'agDateColumnFilter', filterParams: filterLastUpdate, suppressMenu: true, sortable: true,
      cellRenderer: params => {
        return getCellView('collection_date', params, props)
      }
    },
    { headerName: 'Fecha Deseada de Entrega', field: 'delivery_date', minWidth: 310, filter: 'agDateColumnFilter', filterParams: filterLastUpdate, suppressMenu: true, sortable: true,
      cellRenderer: params => {
        return getCellView('delivery_date', params, props)
      }
    },
    { headerName: 'QTY de SKUs Únicos', field: 'unique_skus', suppressMenu: true, filter: 'agTextColumnFilter', minWidth: 200, sortable: true },
    { headerName: 'Peso Bruto Total', field: 'gross_weight_total', suppressMenu: true, filter: 'agTextColumnFilter', minWidth: 200, sortable: true,
      cellRenderer: params => {
        return getCellView('gross_weight_total', params, props)
      }
    },
    { headerName: 'Peso Neto Total', field: 'net_weight_total', suppressMenu: true, filter: 'agTextColumnFilter', minWidth: 200, sortable: true,
      cellRenderer: params => {
        return getCellView('net_weight_total', params, props)
      }
    },
    { headerName: 'Volumen Total', field: 'total_volume', suppressMenu: true, filter: 'agTextColumnFilter', minWidth: 200, sortable: true },
    { headerName: 'CTA', field: 'cta', minWidth: 230, suppressMenu: true, 
      cellRenderer: params => {
        return getCellView('cta', params, props)
      }
    },
    { headerName: 'Acciones', field: 'delivery_id', minWidth: 200, suppressMenu: true, tooltipField: 'delivery_id',
      cellRenderer: params => {
        return getCellView('delivery_id', params, props)
      }
    }
  ];

  let new_def = applyNewColumns(cloneDeep(default_columns), props);

  if (new_def && new_def.length > 0) {
    default_columns = new_def;
  }
  
  const [colDefs, setColDefs] = useState(default_columns);

  const defaultColDef = useMemo(() => {
    return {
      resizable: true,
      floatingFilter: true,
      tooltipComponent: params => {
        return(
          <div
            style={{
              backgroundColor: 'black',
              color: 'white',
              padding: 10,
              borderRadius: 10
            }}
          >
            {/* <div
              style={{cursor: 'pointer'}}
              onClick={() => {
                props.handleChange({
                  target: {
                    name: "delete-delivery",
                    value: 'Función de eliminar entrega'
                  }
                })
              }}
            >{'Eliminar Entrega'}</div>
            <div style={{height: 8}}/>
            <div
              style={{cursor: 'pointer'}}
              onClick={() => {
                props.handleChange({
                  target: {
                    name: "unlink",
                    value: 'Función de desvincular'
                  }
                })
              }}
            >{'Desvincular'}</div> */}
          </div>
        );
      },
    };
  }, []);

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
      pinned: "left",
    };
  }, []);

  const onGridReady = useCallback((params) => {

    if (props.allSelected) {
      params.api.forEachNode( node => {
        node.setExpanded(true);
      });
    }

    setCalled(true);

  }, []);

  const updateAggridConf = (params) => {
    if (called) {
      let config = {
        columns: params.api.getColumnDefs(),
        filter: params.api.getFilterModel()
      };

      if (props.setNewFilter) {
        props.setNewFilter(config);
      }
    }
  };

  const detailCellRendererParams = useMemo(() => {
    return {
      detailGridOptions: {
        rowHeight: 50,
        columnDefs: [
          { headerName: '', field: 'product_id_checkbox', suppressMenu: true,  minWidth: 80, width: 80, sortable: true, checkboxSelection: true },
          { headerName: 'Nombre del Producto', field: "name", suppressMenu: true, //checkboxSelection: true, headerCheckboxSelection: true se oculta por mientras
          },
          { headerName: 'Nombre', field: "name", suppressMenu: true },
          { headerName: 'SKU', field: "sku", suppressMenu: true },
          { headerName: 'Cantidad', field: "quantity", suppressMenu: true,
            cellRenderer: params => {
              return getCellView('qty', params || {}, props);
            }
          },
          { headerName: 'Peso Neto', field: "net_weight", suppressMenu: true },
          { headerName: 'Peso Bruto por SKU', field: "gross_weight", suppressMenu: true },
          { headerName: 'Volumen por SKU', field: "volume", suppressMenu: true },
          { headerName: 'CTA', field: 'cta', suppressMenu: true, 
            cellRenderer: params => {
              const isRow = params.node.data;
              if (!isRow) { return <div></div> }

              return(
                <div style={{width: '100%', height: '50px', display: 'flex', alignItems: 'center'}}>

                  {
                    params.node.parent.allChildrenCount > 1 &&
                    <img
                      alt=""
                      src="/images/bin.png"
                      style={{ cursor: "pointer", marginLeft: 10}}
                      onClick={() => {
                        let code = '';

                        (props.rowData || []).map( item => {
                          if (item.id === params.data.delivery_id) {
                            code = `${item.requisition_code}-${item.suffix}`
                          }
                        })

                        props.handleChange({
                          target: {
                            name: "remove_unique_product_data",
                            value: {
                              id: params.data.delivery_id,
                              products: [{id: params.data.product_delivery_id, product_name: params.data.product_name}],
                              code
                            }
                          }
                        });
                      }}
                    />
                  }

                </div>
              );
            }
          }
        ],
        rowSelection: 'multiple',
        defaultColDef: {
          flex: 1
        },
        suppressRowClickSelection: true,
        onRowSelected: params => {
          let selected = params.api.getSelectedRows().map( item => item.product_delivery_id);
          let all_ids = [];

          (params?.node?.parent?.allLeafChildren || []).map( item => {
            let product_id = {id: item.data.product_delivery_id, selected: selected.includes(item.data.product_delivery_id), delivery_id: item.data.delivery_id, product_name: item.data.product_name };
            all_ids.push(product_id);
          });

          props.handleChange({
            target: {
              name: "products_selected",
              value: all_ids
            }
          });
        },
        // getRowId: params => {
        //   return String(params.data.product_delivery_id);
        // },
        onGridReady: params => {
          if (props.allSelected) {
            params.api.forEachNode( node => {
              node.setSelected(true);
            });
          }
        }
      },
      getDetailRowData: (params) => {
        params.successCallback(params.data.products);
      },
    };
  }, []);

  const getRowHeight = useCallback((params) => {
    const isDetailRow = params.node.detail;
    // for all rows that are not detail rows, return nothing
    if (!isDetailRow) { return undefined; }

    // otherwise return height based on number of rows in detail grid
    const detailPanelHeight = ((params.data?.products || []).length * 52) + 50;
    return detailPanelHeight < 50 ? 150 : detailPanelHeight;
  }, []);

  return (
    <div>

      <div
        className="ag-theme-alpine"
        style={{ height: 650, marginBottom: 50 }}
      >
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={colDefs}
          enableCellTextSelection={true}
          suppressRowClickSelection={true}
          rowHeight={50}
          detailCellRendererParams={detailCellRendererParams}
          masterDetail={true}
          getRowHeight={getRowHeight}
          rowSelection="multiple"
          localeText={AG_GRID_LOCALE_ES}
          defaultColDef={defaultColDef}
          tooltipShowDelay={500}
          tooltipInteraction={true}
          keepDetailRows={true}
          onGridReady={onGridReady}
          getRowId = { params => {
            return String(params.data.delivery_id);
          }}
          gridOptions={{
            sideBar: {
              toolPanels: ['columns', 'filters'],
              position: 'right',
              defaultToolPanel: '',
            },
          }}

          groupDisplayType={"groupRows"}
          rowGroupPanelShow={"always"}
          autoGroupColumnDef={autoGroupColumnDef}
          enableCharts={true}
          enableRangeSelection={true}
          onFilterChanged={ params => {
            updateAggridConf(params);
          }}
          onColumnMoved={ params => {
            if (params.finished) {
              updateAggridConf(params);
            }
          }}
          onColumnVisible={ params => {
            updateAggridConf(params);
          }}
        />
      </div>
    </div>
  );
}